import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'tss-react/mui';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Logo from '../../static/img/logoRedWhite.webp';
// import FaceBookIcon from '../../static/img/icons/facebook.svg';

const styles = theme => ({
  center: {
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  centerImgSec: {
    paddingLeft: theme.spacing(),
    [theme.breakpoints.up(600)]: {
      paddingLeft: theme.spacing(3),
    },
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  footer: {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    backgroundColor: theme.palette.secondary.main,
    padding: theme.spacing(3),
    margin: '0 auto',
    display: 'flex',
    color: 'white',
    justifyContent: 'space-between',
    // minHeight: 220,
    [theme.breakpoints.down(600)]: {
      minHeight: 554,
    },
  },
  footerText: {
    color: 'white',
  },
  bigFooterText: {
    color: 'white',
    textTransform: 'uppercase',
  },
  link: {
    color: 'white',
    textDecoration: 'none',
  },
  contactLink: {
    color: 'white',
    textDecoration: 'none',
    [theme.breakpoints.down(600)]: {
      display: 'none',
    },
  },
  graphic: {
    width: '50%',
    marginBottom: theme.spacing(),
  },
  faceBookIcon: {
    height: '20px',
    width: 'auto',
  },
  imageLink: {
    width: '20px',
  },
  divider: {
    [theme.breakpoints.down(600)]: {
      display: 'none',
    },
  },
});

const text = {
  address: '6312 SW Capitol Highway #144, Portland, OR 97239',
  copyWrite: '©' + new Date().getFullYear() + ' Nia Technique, Inc.',
  contact: 'Contact:',
  contactPhone: 'Phone: (503) 245-9886',
  contactFax: 'Fax: (503) 245-2159',
  contactTollFree: 'Toll-free: (800) 762-5762',
  Email: 'Email us',
  Feedback: 'Feedback',
  Hours: 'Monday-Friday 9am-5pm PT',
  Follow: 'Follow',
  Blog: 'Blog/Community',
};

function Footer(props) {
  const { classes } = props;
  return (
    <Grid container className={classes.footer}>
      <Grid className={classes.centerImgSec} item xs={12} sm={3}>
        <img className={classes.graphic} alt="Nia" src={Logo} />
        <Typography className={classes.bigFooterText}>{text.address}</Typography>
        <Typography className={classes.footerText}>{text.Hours}</Typography>
        <Typography className={classes.footerText}>{text.copyWrite}</Typography>
      </Grid>
      <hr className={classes.divider} />
      <Grid className={classes.center} item xs={12} sm={3}>
        {/*<Typography className={classes.footerText}>{text.contactNumbers}</Typography>
        <Typography className={classes.footerText}>{text.contactTollFree}</Typography>
        <Typography className={classes.footerText}>{text.contactFax}</Typography>*/}
        <Typography><Button size="small" color="primary" href="/blog">{text.Blog}</Button></Typography>
        <Typography><Button size="small" color="primary" href="mailto:nia@nianow.com">{text.Email}</Button></Typography>
        <Typography><Button size="small" color="primary" href="mailto:feedback@nianow.com">{text.Feedback}</Button></Typography>
        <Typography><Button size="small" color="primary" href="/privacy">Privacy Policy</Button></Typography>
        <Typography><Button size="small" color="primary" href="/terms">Terms + Conditions</Button></Typography>
        <Typography><Button size="small" color="primary" href="/dei">DEI Commitments</Button></Typography>
      </Grid>
      <hr className={classes.divider} />
      <Grid className={classes.center} item xs={12} sm={3}>
        <Typography><Button size="small" color="primary" href="/finder/class">Classes</Button></Typography>
        <Typography><Button size="small" color="primary" href="/finder/training">Trainings</Button></Typography>
        <Typography><Button size="small" color="primary" href="/membership">Membership</Button></Typography>
        {/*<Typography className={classes.footerText}>{text.Follow}</Typography>
        <a className={classes.imageLink} href="https://www.facebook.com/NiaTechnique"><img className={classes.faceBookIcon} alt="Facebook Icon" src={FaceBookIcon} /></a>*/}
      </Grid>
    </Grid>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(Footer, styles);
